<template>
  <div class="trophy-container">
    <div class="trophy-content">
      <div class="trophy-text">
        <div v-if="showTrophyType === 'self'" class="self-trophy">
          <img src="@saas/pages/assets/images/live/trophy-self.png" alt="" />
        </div>
        <div v-if="showTrophyType === 'other'" class="other-trophy">
          <div class="name">{{ otherNickname || "-" }}</div>
          <img src="@saas/pages/assets/images/live/trophy-other.png" alt="" />
        </div>
        <div v-if="showTrophyType === 'all'" class="all-trophy">
          <img
            src="@saas/pages/assets/images/live/trophy-all-people.png"
            alt=""
          />
        </div>
      </div>
      <div class="trophy-gif">
        <img src="@saas/pages/assets/images/live/trophy.gif" alt="" />
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import { showConfetti } from "../../utils/canvas-confetti.js";
import { mapMutations, mapState } from "vuex";
export default {
  name: "Trophy",
  props: {},
  data() {
    return {
      trophyTimer: null,
      trophyAudio: null,
    };
  },
  computed: {
    ...mapState("live", [
      "roomInfo",
      "userStatus",
      "allMemberStatusMap",
      "showTrophy",
    ]),
    showTrophyType() {
      const userId = this.showTrophyInfo.userId;
      if (
        userId === this.userStatus.user_id ||
        (this.roomInfo.isStudent && userId === "*")
      ) {
        return "self";
      } else if (userId === "*") {
        return "all";
      } else {
        return "other";
      }
    },
    otherNickname() {
      return (
        this.allMemberStatusMap[this.showTrophyInfo.userId]?.nickname || "-"
      );
    },
    showTrophyInfo() {
      return this.showTrophy.info || {};
    },
  },
  mounted() {
    showConfetti();
    this.initTrophyAudio();
    this.trophyTimer = setTimeout(() => {
      this.setShowTrophy({
        visible: false,
        info: {},
      });
    }, 3000);
  },
  beforeDestroy() {
    clearTimeout(this.trophyTimer);
    this.trophyAudio.pause();
  },
  methods: {
    ...mapMutations("live", ["setShowTrophy"]),
    initTrophyAudio() {
      this.trophyAudio = document.createElement("audio");
      this.trophyAudio.src =
        "https://cdn.moguocdn.com/cdn/static/audio/trophy.m4a";
      this.trophyAudio.play();
    },
  },
};
</script>

<style lang="scss" scoped>
.trophy-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(7px);
    background-color: rgba(0, 0, 0, 0.2);
  }
  .trophy-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .trophy-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .self-trophy {
        width: 315px;
      }
      .other-trophy {
        position: relative;
        width: 485px;
        .name {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 96px;
          width: 180px;
          text-align: center;
          font-weight: 600;
          font-size: 38px;
          height: 100%;
          line-height: 60px;
          text-shadow: 0px 8px 32px rgba(255, 224, 166, 0.7);
          background: linear-gradient(180deg, #f0b361 0%, #ffea6e 100%);
          color: transparent;
          background-clip: text;
          -webkit-background-clip: text;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .all-trophy {
        width: 420px;
      }
    }
    .trophy-gif {
      width: 150px;
      height: 150px;
    }
  }
}
</style>
